/**
 * Id aleatório desta aba (muda a cada carregamento). Vai na conexão do Socket.IO e no pedido do
 * ramal: o servidor sabe qual aba está com o telefone e se ela ainda está aberta.
 */
export const CLIENT_ID: string = crypto.randomUUID();

/**
 * Identifica esta aba entre carregamentos (sessionStorage): o servidor guarda qual aba abriu a
 * sessão de foco, e a conexão do Socket.IO desta aba conta como sinal de vida dessa sessão.
 */
export const TAB_ID: string = (() => {
  try {
    const existing = sessionStorage.getItem('atd.tab');
    if (existing) return existing;
    const id = crypto.randomUUID();
    sessionStorage.setItem('atd.tab', id);
    return id;
  } catch {
    return crypto.randomUUID();
  }
})();
